import React, {useState} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';

import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Button, Flex, Image, Text} from 'rebass';
import {FloatingButton} from "../Base/Buttons";
import {PositionBox, Toolbar} from "../Base";
import check from '../../resources/img/icons/Checkbox@1x.png'
import IosClose from 'react-ionicons/lib/IosClose'

import {returnFilterString} from "../../utils";
import {INITIAL_LEAVE_FILTER, INITIAL_STUDENT_FILTER} from '../../utils/filters'
import Filters from './StudentFilters'
import LeaveFilters from './LeaveFilters'

import {schoolSelectors} from "../../store/school";
import {authSelectors} from "../../store/auth";
// import {searchSelectors} from "../../store/search";
import {Arrow, FilterOverlay, HeaderWrapper, Title} from './styles'
import {ActiveCircle, InactiveCircle} from "../Base/Icons";


function ApplyLeaveFilters(props) {
	const [filterTab, setTab] = useState(0)


	const { isLoading, school, updateFilters, current, clearFilter} = props;
	const updateStudentFilters = (newStudentFilters) => {
		console.log(current)
		updateFilters(newStudentFilters, 'student', current)
	}
	const updateLeaveFilters = (newLeaveFilters) => {
		updateFilters(newLeaveFilters, 'leaves', current)

	}

	const handleClearFilter = () => {
		if(filterTab === 0){
			clearFilter('student', current)

		} else {
			clearFilter('leaves', current)

		}
	}


	// let {filters} = props;
	const {filters} = props
	let studentFilters = filters.student
	const leaveFilters = filters.leaves
	if (!studentFilters.type) {
		studentFilters = {
			...filters,
			type: []
		}
	}
	//
	let filterTitle = isLoading ? 'Apply Filters' : returnFilterString(studentFilters, school)
	//
	// if(isCheckin){
	// 	filterTitle = title
	// }

	// const filterTitle = 'Apply Filters'

	return (
		<Overlay.Container>
			{overlay => (
				<Block>
					<Flex  {...overlay} onClick={overlay.show}>
						<Box>
							<Text color='#969a9b'>
								{filterTitle && filterTitle.length < 25 ? filterTitle :
									<Truncate lines={1}>
										{filterTitle}
									</Truncate>}
							</Text>
						</Box>
						<Box> <Arrow color={'#969a9b'} fontSize={'17px'}/> </Box>
					</Flex>
					<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
					<FilterOverlay use={Portal} {...overlay} padding={0} margin={0}>

						<FloatingButton bg={'purple'} bottom={'80px'} onClick={overlay.hide}><Image src={check}/>

						</FloatingButton>
						<Box>
							<HeaderWrapper>

								<Flex>
									<Box>
										<IosClose onClick={overlay.hide} fontSize={'40px'} color={'black'}/>
									</Box>
									<Box mr={'auto'}/>
									<Box>
										<Button onClick={() => {
											handleClearFilter()
											overlay.hide()
										}}>Clear</Button>
									</Box>
								</Flex>
								<Title>Filters</Title>
							</HeaderWrapper>

							<Block>
								<PositionBox position={['relative', 'default']} top={'-40px'}>

									{filterTab === 0 ?
										<Filters handleUpdate={updateStudentFilters} filters={studentFilters}/>
										:
										<LeaveFilters filters={leaveFilters} handleUpdate={updateLeaveFilters}/>
									}
								</PositionBox>
							</Block>


						</Box>
						<Toolbar width={1} minHeight={'69px'} bg='gray' flexWrap='wrap' flexDiretion='row'
						         justifyContent='center'
						         position={['fixed']} bottom={0}>
							<Flex width={1/2} flexDiretion='row' justifyContent='center'>
							<Flex px={2} flexDirection={'column'} flexWrap={'wrap'} justifyContent={'center'} onClick={() => setTab(0)}>
							{filterTab !== 0 ? <InactiveCircle/> : <ActiveCircle/>}
							</Flex>
							</Flex>
							<Flex width={1/2} flexDiretion='row' justifyContent='center' onClick={() => setTab(1)}>
							<Flex px={2} flexDirection={'column'} flexWrap={'wrap'} justifyContent={'center'}>
							{filterTab === 0 ? <InactiveCircle/> : <ActiveCircle/>}
							</Flex>
							</Flex>
						</Toolbar>
					</FilterOverlay>
				</Block>
			)}
		</Overlay.Container>
	)
}

ApplyLeaveFilters.propTypes = {
	dormView: PropTypes.bool,
	isCheckin: PropTypes.bool,
	title: PropTypes.string,
	filters: PropTypes.object,
	leaveFilters: PropTypes.object,
	// updateStudentFilters: PropTypes.func,
	// updateLeaveFilters: PropTypes.func,
	current: PropTypes.number
};

ApplyLeaveFilters.defaultProps = {
	dormView: false,
	isCheckin: false,
	checkinFilters: {
		grade: [],
		location: [],
		dorm: [],
		gender: [],
		type: []
	},
	filters: {

			student: INITIAL_STUDENT_FILTER,
			leaves: INITIAL_LEAVE_FILTER


	},
	leaveFilters: {
		students: [],
		actors: [],
		type: [],
		leaveBy: [],
		returnBy: [],
		leaveAt: null,
		returnAt: null
	},
	title: "Apply Filters",
	// updateStudentFilters: (filters) => console.log('ApplyLeaveFilter student filters',filters),
	// updateLeaveFilters: (filters) => console.log('ApplyLeaveFilter leave filters',filters)
	updateFilters: (filters, type, tab) => console.log('ApplyLeaveFilter leave filters',filters, type, tab)
};

const mapStateToProps = (state) => ({
	school: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	// loading: authSelectors.isLoading(state.auth),
	// searchFilters: searchSelectors.refreshFilters(state.search),
	// extraCheckinFilters: searchSelectors.refreshCheckinFilters(state.search),
	isLoading: schoolSelectors.isLoading(state.school),
	// filters: leavesSelectors.refreshFilters(state.leaves)
});

export default connect(mapStateToProps)(ApplyLeaveFilters)
